import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {CopilotCodeReviewFeedback} from '@github-ui/copilot-review-feedback'

registerReactPartial('copilot-code-review-feedback', {
  Component: CopilotCodeReviewFeedback,
})
